module.exports = __webpack_public_path__ + "static/media/speech-bubble.9da111c9.png";